import { observer } from 'mobx-react-lite';
import React from 'react';
import { moduleStore } from '@tools/ui-stores';
import { ColorModule } from '@tools/ui-utils/theme.util';
import { RectangleModule, RectangleType } from '../RectangleModule';
import { SideMenuPopover } from '../SideMenuPopover';
import PopoverUserProfile from './PopoverPlatformHub.component';

const PlatformHub: React.FC<React.PropsWithChildren> = observer(() => {
  const { activeModule } = moduleStore;

  return (
    <SideMenuPopover width={280} top={10} left={90} content={<PopoverUserProfile />}>
      <>
        <RectangleModule
          type={RectangleType.sideContainer}
          name={activeModule?.name || ''}
          color={activeModule?.color as ColorModule}
        />
      </>
    </SideMenuPopover>
  );
});

export default PlatformHub;
